import Mutations from '../../odata/mutations';

export default { ...new Mutations('notificationReceipt'), ...new Mutations('notificationReceipts') };
